<ion-header>
	<app-header [showBackBtn]="false" [showLangWithAddress]="true"></app-header>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding sheet">
	<div class="content-wrapper">
		<ion-icon class="timeout-icon" name="time-outline"></ion-icon>
		<h2 class="title">{{ 'paymentTimeout.title' | translate }}</h2>

		<p [innerHTML]="'paymentTimeout.message' | translate" class="message"></p>
	</div>
</ion-content>
<ion-footer class="ion-padding">
	<ion-button (click)="close()" class="confirm" expand="block"> {{ 'common.understood' | translate }}</ion-button>
</ion-footer>
